__turbopack_context__.v({
  "className": "inter_a208a963-module__lAxQpW__className",
});
